import { useQuery as useStyleQuizQuery } from "@faire/web-api--source/endpoints/www/api/style-quiz/get-hooks";
import { useMutation as useStyleQuizMutation } from "@faire/web-api--source/endpoints/www/api/style-quiz/styleQuizToken/post-hooks";
import { IStyleQuiz } from "@faire/web-api--source/indigofair/data/IStyleQuiz";
import { useCallback } from "react";

// Style quiz should rarely be updated, so we can use a longer stale timeout
// currently set to 5 minutes.
const STALE_TIMEOUT = 5 * 60 * 1000;

export const useStyleQuizStore = () => {
  const { data: styleQuiz, refetch } = useStyleQuizQuery({
    refetchOnMount: false,
    staleTime: STALE_TIMEOUT,
  });

  const { mutateAsync: updateStyleQuiz } = useStyleQuizMutation({
    onSuccess: () => {
      refetch();
    },
  });

  const update = useCallback(
    async (updatedStyleQuiz: Partial<IStyleQuiz>) => {
      const token = updatedStyleQuiz.token ?? styleQuiz?.token;

      if (!token) {
        return;
      }

      await updateStyleQuiz([
        token,
        IStyleQuiz.build({ ...updatedStyleQuiz, token }),
      ]);
    },
    [styleQuiz?.token, updateStyleQuiz]
  );

  const fetchStyleQuiz = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    styleQuiz,
    update,
    fetchStyleQuiz,
  };
};
